import React, { useEffect, useRef, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FileBase64 from 'react-file-base64';
import { resizeImage } from 'function/resizeImage';
import { Formik } from 'formik';
import * as Yup from 'yup';
import SubCard from 'ui-component/cards/SubCard';

import {
    Alert,
    Box,
    Button,
    CardMedia,
    Collapse,
    FormControl,
    FormHelperText,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    TextField,
    Typography,
    useMediaQuery
} from '@mui/material';
import axios from 'axios';
import ApiLink from 'API';
import { useTheme } from '@mui/styles';
import useScriptRef from 'hooks/useScriptRef';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { gridSpacing } from 'store/constant';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router';
import JoditEditor from 'jodit-pro-react';
const InvoiceSetting = ({ open, setOpen, loadData }) => {
    const editor = useRef(null);
    const [Data, setData] = useState({});
    const config = {
        uploader: {
            insertImageAsBase64URI: true,
            // isSuccess: function (resp) {
            //   console.log(resp);
            //   return resp;
            // },
            // process: function (resp) {
            //   // resizeImage(resp.data.files, 800, 800).then((data) => {
            //   //   console.log(resp.data.files);
            //   //   return {
            //   //     files: data,
            //   //     path: resp.data.path,
            //   //     baseurl: resp.data.baseurl,
            //   //     error: resp.data.error,
            //   //     message: resp.data.message,
            //   //   };
            //   // });
            //   return {
            //     files: resp.data.files,
            //     path: resp.data.path,
            //     baseurl: resp.data.baseurl,
            //     error: resp.data.error,
            //     message: resp.data.message,
            //   };
            // },
            defaultHandlerSuccess: function (data) {
                var i,
                    field = 'files';
                if (data[field] && data[field].length) {
                    for (i = 0; i < data[field].length; i += 1) {
                        resizeImage(data[field][i], 600, 600).then((base64) => {
                            // console.log(data.baseurl + base64);
                            this.selection.insertImage(data.baseurl + base64);
                        });
                    }
                }
            }
        },
        readonly: false,
        width: 'auto',
        height: 'auto',
        minHeight: 400,
        disablePlugins: 'about,video',
        buttons: [
            'source',
            '|',
            'bold',
            'strikethrough',
            'underline',
            'italic',
            '|',
            'ul',
            'ol',
            '|',
            'outdent',
            'indent',
            'lineHeight',
            '|',
            'fontsize',
            'brush',
            'paragraph',
            '|',
            'image',
            'table',
            'link',
            '|',
            'align',
            'undo',
            'redo',
            '|',
            'hr',
            'eraser',
            'copyformat',
            '|',
            'symbol',
            'fullsize',
            'print'
        ],
        style: {
            fontFamily: 'Phetsarath OT'
        }
        // controls: {
        //     font: {
        //         list: {
        //             '': 'Default'
        //             // '': 'Phetsarath OT',
        //             // '': 'Helvetica',
        //             // '': 'Arial',
        //             // '': 'Georgia',
        //             // '': 'Impact',
        //             // '': 'Tahoma',
        //             // '': 'Times New Roman',
        //             // '': 'Verdana'
        //         }
        //     }
        // }
        //zIndex: 1
    };
    async function LoadData() {
        try {
            const respon = await axios.get(ApiLink + '/api/stockcustomer/data/detail', {
                withCredentials: true,
                headers: {
                    token: localStorage.getItem('token')
                }
            });
            if (respon.status === 200) {
                // console.log(responce.data);

                setData(respon.data.data);
            }
        } catch (error) {
            console.log(error);
            if (error.response.status === 401) {
                localStorage.clear();
                navigate(0);
            }
        }
    }
    const handleClose = () => {
        setOpen(false);
    };
    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);
    const theme = useTheme();
    const navigate = useNavigate();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    const scriptedRef = useScriptRef();
    const [AlertBox, setAlertBox] = useState({ open: false, message: '', severity: 'error' });

    useEffect(() => {
        LoadData();
    }, []);
    return (
        <div>
            <Dialog
                fullScreen
                disableEnforceFocus
                fullWidth
                maxWidth="md"
                open={open}
                onClose={handleClose}
                scroll="paper"
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title">
                    <Typography variant="caption" sx={{ color: '#00c853' }}>
                        Edit
                    </Typography>{' '}
                    {Data.customerName}
                </DialogTitle>
                <DialogContent dividers={true}>
                    <Collapse in={AlertBox.open}>
                        <Alert
                            sx={{ padding: '10px', mb: 2 }}
                            // variant="outlined"
                            severity={AlertBox.severity}
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setAlertBox({ ...AlertBox, open: false });
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                        >
                            {AlertBox.message}
                        </Alert>
                    </Collapse>
                    <DialogActions id="scroll-dialog-description" ref={descriptionElementRef} tabIndex={-1}>
                        <Formik
                            initialValues={{
                                images: Data.images,
                                html: Data.html
                            }}
                            validationSchema={Yup.object().shape({
                                images: Yup.string(),
                                html: Yup.object()
                            })}
                            onSubmit={async (values, { setErrors, setSubmitting, resetForm }) => {
                                console.log(scriptedRef.current);

                                try {
                                    if (scriptedRef.current) {
                                        // alert(JSON.stringify(values, null, 2));

                                        await axios
                                            .put(ApiLink + '/api/stockcustomer/update/detail', values, {
                                                withCredentials: true,
                                                headers: {
                                                    token: localStorage.getItem('token')
                                                }
                                            })
                                            .then((res) => {
                                                // console.log(res.data);
                                                setOpen(false);
                                                // setAlertBox({ open: true, message: 'Add success', severity: 'success' });
                                                resetForm();
                                                LoadData();
                                                loadData('');
                                            })
                                            .catch((error) => {
                                                try {
                                                    if (error.response.status === 400 || error.response.status === 500) {
                                                        setAlertBox({ open: true, message: error.response.data.msg, severity: 'error' });
                                                    } else {
                                                        setAlertBox({ open: true, message: error.response.statusText, severity: 'error' });

                                                        // console.log(error.response.statusText);
                                                    }
                                                } catch (error) {
                                                    setAlertBox({ open: true, message: error, severity: 'error' });
                                                }
                                            });

                                        setSubmitting(false);
                                    } else {
                                        console(values);
                                    }
                                } catch (err) {
                                    console.error(err);
                                    if (scriptedRef.current) {
                                        setErrors({ submit: err.message });
                                        setSubmitting(false);
                                    }
                                }
                            }}
                        >
                            {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values, setFieldValue }) => (
                                <form noValidate onSubmit={handleSubmit} style={{ width: '100%' }}>
                                    <Grid container>
                                        {/* <Grid item xs={12} sm={12} md={4} lg={4} align="center"></Grid> */}
                                        <Grid item xs={12} sm={12} md={12} lg={12}>
                                            <Grid container spacing={matchDownSM ? 1 : 2}>
                                                <Grid item xs={12} md={12}>
                                                    <Stack>
                                                        <p>Logo</p>
                                                        <CardMedia
                                                            image={values.images}
                                                            sx={{
                                                                mb: 3,
                                                                bgcolor: 'primary.light',
                                                                maxWidth: 200,
                                                                height: 200,
                                                                objectFit: 'cover'
                                                            }}
                                                        >
                                                            <Button
                                                                // fullWidth
                                                                hidden
                                                                sx={{
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                    height: 200
                                                                    // py: 4.5
                                                                    // bgcolor: 'primary.light',
                                                                    // color: '#E3F2FD'
                                                                }}
                                                                component="label"
                                                            >
                                                                <Box hidden>
                                                                    <FileBase64
                                                                        type="file"
                                                                        name="images"
                                                                        multiple={false}
                                                                        onDone={(data) => {
                                                                            resizeImage(data.base64, 400, 400).then((result) => {
                                                                                setFieldValue('images', result);
                                                                                // console.log(result);
                                                                            });
                                                                        }}
                                                                    />
                                                                </Box>
                                                                <Typography variant="subtitle1" color="#ffffff">
                                                                    {values.images !== '' ? null : 'Upload Image'}
                                                                </Typography>
                                                            </Button>
                                                        </CardMedia>
                                                    </Stack>
                                                    {touched.images && errors.images && (
                                                        <FormHelperText error id="standard-weight-helper-text--register">
                                                            {errors.images}
                                                        </FormHelperText>
                                                    )}
                                                </Grid>
                                                <Grid item xs={12} md={12}>
                                                    <Stack>
                                                        <p>Footer</p>
                                                        <JoditEditor
                                                            ref={editor}
                                                            value={values.html?.footer}
                                                            config={config}
                                                            onBlur={(TextHTML) => {
                                                                setFieldValue('html', { footer: TextHTML });
                                                            }}
                                                            // onChange={(newContent) => {
                                                            //   console.log(newContent);
                                                            // }}
                                                        />
                                                    </Stack>
                                                    {touched.html && errors.html && (
                                                        <FormHelperText error id="standard-weight-helper-text--register">
                                                            {errors.html}
                                                        </FormHelperText>
                                                    )}
                                                </Grid>
                                            </Grid>

                                            {errors.submit && (
                                                <Box sx={{ mt: 3 }}>
                                                    <FormHelperText error>{errors.submit}</FormHelperText>
                                                </Box>
                                            )}

                                            <Box sx={{ mt: 2 }}>
                                                <AnimateButton>
                                                    <Button
                                                        disableElevation
                                                        disabled={isSubmitting}
                                                        fullWidth
                                                        size="large"
                                                        type="submit"
                                                        variant="contained"
                                                        color="secondary"
                                                    >
                                                        save
                                                    </Button>
                                                </AnimateButton>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </form>
                            )}
                        </Formik>
                    </DialogActions>
                    {/* <DialogContentText id="scroll-dialog-description" ref={descriptionElementRef} tabIndex={-1}>
                        {[...new Array(50)]
                            .map(
                                () => `Cras mattis consectetur purus sit amet fermentum.
Cras justo odio, dapibus ac facilisis in, egestas eget quam.
Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
Praesent commodo cursus magna, vel scelerisque nisl consectetur et.`
                            )
                            .join('\n')}
                    </DialogContentText> */}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    {/* <Button onClick={handleClose}>Save</Button> */}
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default InvoiceSetting;
